import {CountryPrefix} from '@/store/models';
import store from '@/store';

function extractPrefix(telephone: string, prefixes: string[], numChar: number = 3) {
    const currentPrefix = prefixes.find((prefix) => {
        return prefix.length === numChar && telephone.startsWith(prefix);
    });

    return currentPrefix;
}

function getDefaultCountryPrefix(prefixes: CountryPrefix) {
    return prefixes[store.state.countryData.defaultCountry] || '';
}

function getPrefixes() {
    return store.state.countryData.countries.reduce<CountryPrefix>((acc, country) => {
        acc[country.code] = country.phone_prefix;
        return acc;
    }, {});
}

export function getPrefix(telephone: string) {
    const prefixes = getPrefixes();

    if (telephone) {
        for (let i = 4; i >= 3; i -= 1) {
            const prefix = extractPrefix(telephone, Object.values(prefixes), i);

            if (prefix) {
                return prefix;
            }
        }
    }

    return getDefaultCountryPrefix(prefixes);
}

export function getTelephoneWithoutPrefix(telephone: string) {
    if (!telephone) {
        return '';
    }

    return telephone.replace(getPrefix(telephone), '');
}
